/**
 * Axiom cart fixes:
 * - Minicart Yes/No remove (wishlist prompt)
 * - Reliable line-item change via line-item key
 * - Buy Now loading reset on back/bfcache
 */
(function () {
  'use strict';

  function shopRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    if (window.routes && window.routes.root) return window.routes.root;
    return '/';
  }

  function cartChangeUrl() {
    if (window.routes && window.routes.cart_change_url) return window.routes.cart_change_url;
    return shopRoot().replace(/\/?$/, '/') + 'cart/change.js';
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    return shopRoot().replace(/\/?$/, '/') + 'cart/add.js';
  }

  function updateCartCounts(cart) {
    if (!cart || cart.item_count == null) return;
    document.querySelectorAll('.cart-count').forEach(function (el) {
      if (el.classList.contains('cart-count-drawer')) {
        el.innerHTML = '(' + cart.item_count + ')';
      } else {
        el.innerHTML = cart.item_count > 100 ? '~' : String(cart.item_count);
      }
    });
    var headerTotal = document.querySelector('header-total-price');
    if (headerTotal && typeof headerTotal.updateTotal === 'function') {
      headerTotal.updateTotal(cart);
    }
  }

  function refreshMinicart(cart) {
    var formEl = document.getElementById('minicart-form');
    if (!formEl) return Promise.resolve();
    var root = shopRoot().replace(/\/?$/, '/');
    return fetch(root + '?sections=minicart-form')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections && sections['minicart-form'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('#minicart-form');
        if (next) formEl.innerHTML = next.innerHTML;
        var bar = document.querySelector('free-ship-progress-bar');
        if (bar && cart && typeof bar.init === 'function') {
          bar.init(cart.items_subtotal_price);
        }
        var cartNotification = document.querySelector('cart-notification');
        if (cartNotification && typeof cartNotification.cartAction === 'function') {
          cartNotification.cartAction();
        }
      })
      .catch(function () {});
  }

  function changeLineQuantity(lineKey, quantity) {
    var qty = Number(quantity);
    if (!lineKey || isNaN(qty) || qty < 0) {
      return Promise.reject(new Error('Invalid cart line'));
    }
    return fetch(cartChangeUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: String(lineKey), quantity: qty }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.errors || data.status) {
          var err = new Error(
            (data && (data.errors || data.description || data.message)) || 'Cart update failed'
          );
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  function refreshCartPage() {
    var main = document.getElementById('main-cart-items');
    if (!main || !main.dataset.id) {
      window.location.reload();
      return Promise.resolve();
    }
    var sectionId = main.dataset.id;
    var root = shopRoot().replace(/\/?$/, '/');
    return fetch(root + 'cart?sections=' + encodeURIComponent(sectionId))
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections && sections[sectionId];
        if (!html) {
          window.location.reload();
          return;
        }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById('main-cart-items') || doc.querySelector('.page-cart');
        if (next) {
          main.innerHTML = next.innerHTML;
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function saveWishlistId(productId) {
    if (!productId) return;
    var raw = localStorage.getItem('glozin__wishlist-items');
    var list = [];
    try {
      list = raw ? JSON.parse(raw) : [];
    } catch (e) {
      list = [];
    }
    if (!Array.isArray(list)) list = [];
    var id = String(productId);
    if (list.indexOf(id) === -1 && list.indexOf(productId) === -1) {
      list.push(id);
      localStorage.setItem('glozin__wishlist-items', JSON.stringify(list));
    }
    if (window.wishlistHeader && typeof wishlistHeader.init === 'function') {
      wishlistHeader.init();
    }
  }

  function cartUpdateUrl() {
    if (window.routes && window.routes.cart_update_url) return window.routes.cart_update_url;
    return shopRoot().replace(/\/?$/, '/') + 'cart/update.js';
  }

  function parseLineKeys(raw) {
    return String(raw || '')
      .split(',')
      .map(function (key) {
        return key.trim();
      })
      .filter(Boolean);
  }

  function keysFromCartRow(el) {
    if (!el) return [];
    var row =
      el.closest('[data-line-keys]') ||
      el.closest('.cart-item') ||
      el.closest('tr.cart-item');
    var raw =
      (el.getAttribute && el.getAttribute('data-line-keys')) ||
      (row && row.getAttribute && row.getAttribute('data-line-keys')) ||
      '';
    var keys = parseLineKeys(raw);
    if (keys.length) return keys;
    var input = row && row.querySelector && row.querySelector('input[name="updates[]"][data-id]');
    var one =
      (input && (input.getAttribute('data-id') || input.dataset.id)) ||
      (el.getAttribute &&
        (el.getAttribute('data-index') || el.getAttribute('data-id') || el.getAttribute('data-key')));
    return one ? [String(one)] : [];
  }

  function updateGroupedLines(keys, quantity) {
    var qty = Number(quantity);
    if (!keys || !keys.length || isNaN(qty) || qty < 0) {
      return Promise.reject(new Error('Invalid cart line'));
    }
    var updates = {};
    if (qty === 0) {
      keys.forEach(function (key) {
        updates[key] = 0;
      });
    } else {
      updates[keys[0]] = qty;
      for (var i = 1; i < keys.length; i++) {
        updates[keys[i]] = 0;
      }
    }
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.errors || data.status) {
          var err = new Error(
            (data && (data.errors || data.description || data.message)) || 'Cart update failed'
          );
          err.payload = data;
          throw err;
        }
        return data;
      });
    });
  }

  function stayOnCurrentPage() {
    window.location.reload();
  }

  function removeMinicartLine(keys, addWishlistProductId) {
    if (addWishlistProductId) saveWishlistId(addWishlistProductId);
    var list = Array.isArray(keys) ? keys : parseLineKeys(keys);
    return updateGroupedLines(list, 0).then(function (cart) {
      updateCartCounts(cart);
      return refreshMinicart(cart).then(function () {
        return cart;
      });
    });
  }

  // Capture-phase handlers so broken theme listeners cannot block Yes/No.
  document.addEventListener(
    'click',
    function (event) {
      var noBtn = event.target.closest('.btn-minicart__remove-js');
      var yesBtn = event.target.closest('.btn-minicart__add-wishlist-js');
      if (!noBtn && !yesBtn) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var btn = yesBtn || noBtn;
      var keys = keysFromCartRow(btn);
      if (!keys.length) return;
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');

      var productId = yesBtn ? yesBtn.getAttribute('data-product-id') : null;
      removeMinicartLine(keys, productId)
        .catch(function () {
          window.alert('Could not update your cart. Please try again.');
        })
        .finally(function () {
          btn.removeAttribute('aria-busy');
        });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var removeBtn = event.target.closest('mini-cart-remove-button');
      if (!removeBtn) return;

      if (removeBtn.classList.contains('action-add-wishlist')) {
        var row = removeBtn.closest('.cart-item');
        var wish = row && row.querySelector('.minicart__wishlist');
        var info = row && row.querySelector('.minicart__product-info');
        if (wish && info) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }
          wish.style.display = 'block';
          info.style.display = 'none';
          return;
        }
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var keys = keysFromCartRow(removeBtn);
      if (!keys.length) return;
      if (removeBtn.getAttribute('aria-busy') === 'true') return;
      removeBtn.setAttribute('aria-busy', 'true');
      removeMinicartLine(keys)
        .catch(function () {
          window.alert('Could not update your cart. Please try again.');
        })
        .finally(function () {
          removeBtn.removeAttribute('aria-busy');
        });
    },
    true
  );

  // Cart page + minicart: quantity using grouped line keys.
  // Ignore product-form quantity fields (pack selector, PDP qty).
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || input.getAttribute('name') !== 'updates[]') return;
      if (input.closest('.product-detail, product-form, sticky-add-cart, [data-axiom-packs]')) return;

      var inCartPage = !!input.closest('cart-items, #main-cart-items');
      var inMinicart = !!input.closest('#minicart-form, cart-notification, .minicart');
      if (!inCartPage && !inMinicart) return;

      var keys = keysFromCartRow(input);
      var qty = parseInt(input.value, 10);
      if (!keys.length || isNaN(qty) || qty < 0) return;

      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      updateGroupedLines(keys, qty)
        .then(function (cart) {
          updateCartCounts(cart);
          if (inCartPage) return refreshCartPage();
          return refreshMinicart(cart);
        })
        .catch(function () {
          window.alert('Could not update quantity. Please try again.');
          if (inCartPage) window.location.reload();
          else {
            refreshMinicart().catch(function () {
              stayOnCurrentPage();
            });
          }
        });
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var remove = event.target.closest('cart-remove-button');
      if (!remove) return;
      if (!remove.closest('#main-cart-items, cart-items')) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      var keys = keysFromCartRow(remove);
      if (!keys.length) {
        var lineKey =
          remove.getAttribute('data-key') ||
          remove.dataset.key ||
          (remove.querySelector('[data-id]') &&
            remove.querySelector('[data-id]').getAttribute('data-id'));
        if (!lineKey) {
          var row = remove.closest('tr.cart-item, .cart-item');
          var qtyInput = row && row.querySelector('input[name="updates[]"][data-id]');
          if (qtyInput) lineKey = qtyInput.getAttribute('data-id');
        }
        if (lineKey) keys = [lineKey];
      }
      if (!keys.length) return;

      updateGroupedLines(keys, 0)
        .then(function (cart) {
          updateCartCounts(cart);
          return refreshCartPage();
        })
        .catch(function () {
          window.alert('Could not remove item. Please try again.');
          window.location.reload();
        });
    },
    true
  );

  function cartClearUrl() {
    return shopRoot().replace(/\/?$/, '/') + 'cart/clear.js';
  }

  function clearCart() {
    return fetch(cartClearUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) throw new Error('Could not clear cart');
      return res.json().catch(function () {
        return { item_count: 0 };
      });
    });
  }

  function clearBuyNowCartIfAbandoned() {
    var flag = null;
    try {
      flag = sessionStorage.getItem('axiom_buy_now_session');
    } catch (e) {
      return;
    }
    if (flag !== '1') return;
    // Still on checkout — keep the Buy Now cart intact.
    if (/checkout/i.test(window.location.pathname + window.location.href)) return;

    try {
      sessionStorage.removeItem('axiom_buy_now_session');
    } catch (e) {}

    clearCart()
      .then(function (cart) {
        updateCartCounts(cart && cart.item_count != null ? cart : { item_count: 0 });
        return refreshMinicart({ item_count: 0, items_subtotal_price: 0 });
      })
      .catch(function () {});
  }

  function resetBuyNowButtons() {
    document.querySelectorAll('[data-axiom-buy-now]').forEach(function (btn) {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      var label = btn.querySelector('.btn-label');
      if (label) label.style.opacity = '';
      var spin = btn.querySelector('.icon-load');
      if (spin) spin.style.opacity = '';
    });
  }

  window.addEventListener('pageshow', function () {
    resetBuyNowButtons();
    clearBuyNowCartIfAbandoned();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      resetBuyNowButtons();
      clearBuyNowCartIfAbandoned();
    }
  });

  // Expose helpers for Buy Now snippet
  window.AxiomCart = {
    refreshMinicart: refreshMinicart,
    updateCartCounts: updateCartCounts,
    /**
     * Buy Now: replace cart with this pack only, then checkout.
     * If the customer leaves checkout, the cart is cleared (Add to Cart items are unaffected
     * unless they used Buy Now after — Buy Now always starts fresh).
     */
    addAndCheckout: function (variantId, quantity) {
      var qty = Number(quantity) || 1;
      try {
        sessionStorage.setItem('axiom_buy_now_session', '1');
      } catch (e) {}

      return clearCart()
        .catch(function () {
          // Continue even if clear fails — still attempt a clean add.
          return null;
        })
        .then(function () {
          return fetch(cartAddUrl(), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({ id: Number(variantId), quantity: qty }),
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok || data.status) {
              throw new Error(data.description || data.message || 'Add to cart failed');
            }
            window.location.href = shopRoot().replace(/\/?$/, '/') + 'checkout';
            return data;
          });
        });
    },
    resetBuyNowButtons: resetBuyNowButtons,
    clearBuyNowCartIfAbandoned: clearBuyNowCartIfAbandoned,
  };
})();

(function () {
  'use strict';

  function shopRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function rootPath() {
    return shopRoot().replace(/\/?$/, '/');
  }

  function appliedDiscountCode() {
    var el = document.querySelector('[data-axiom-discount-code]');
    return el ? String(el.getAttribute('data-axiom-discount-code') || '').trim() : '';
  }

  var WELCOME_CODE = 'Welcome10';
  var PENDING_KEY = 'axiom_pending_discount';

  function getPendingDiscount() {
    try {
      return String(localStorage.getItem(PENDING_KEY) || '').trim();
    } catch (e) {
      return '';
    }
  }

  function setPendingDiscount(code) {
    try {
      if (code) localStorage.setItem(PENDING_KEY, String(code).trim());
      else localStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }

  function checkoutUrl(code) {
    if (code) return rootPath() + 'checkout?discount=' + encodeURIComponent(code);
    return rootPath() + 'checkout';
  }

  function expireCookie(name, domain) {
    var expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0';
    var parts = [
      name + '=; path=/; ' + expires,
      name + '=; path=/; ' + expires + '; SameSite=Lax',
      name + '=; path=/; ' + expires + '; SameSite=None; Secure',
    ];
    parts.forEach(function (base) {
      document.cookie = domain ? base + '; domain=' + domain : base;
    });
  }

  function clearDiscountCookies() {
    var host = location.hostname || '';
    var domains = ['', host];
    if (host.indexOf('.') !== -1) {
      domains.push('.' + host);
      var parts = host.split('.');
      if (parts.length > 2) {
        domains.push('.' + parts.slice(-2).join('.'));
      }
    }
    ['discount_code', 'discount', 'cart_discount'].forEach(function (name) {
      domains.forEach(function (domain) {
        expireCookie(name, domain);
      });
    });
    try {
      localStorage.removeItem('discount_code');
    } catch (e) {}
  }

  function removeDiscountCode(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
    clearDiscountCookies();
    var root = rootPath();
    var btn = event && event.target && event.target.closest('[data-axiom-discount-clear]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' }),
    })
      .then(function (res) {
        return res.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        clearDiscountCookies();
        if (window.AxiomCart && cart && typeof window.AxiomCart.updateCartCounts === 'function') {
          window.AxiomCart.updateCartCounts(cart);
        }
        var refresh = refreshMinicartInPlace(cart);
        if (document.getElementById('main-cart-items')) {
          return refresh.then(function () {
            window.location.reload();
          });
        }
        return refresh;
      })
      .catch(function () {
        showCouponError('Could not remove code. Try again.');
      })
      .finally(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  function couponErrorEl() {
    return document.querySelector('.axiom-minicart-coupon__error');
  }

  function showCouponError(message) {
    var el = couponErrorEl();
    if (!el) {
      if (message) window.alert(message);
      return;
    }
    if (!message) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = message;
  }

  function codeAppliedInCart(cart, code) {
    var want = String(code || '').trim().toLowerCase();
    if (!want || !cart) return false;
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      var title = String((apps[i] && (apps[i].title || apps[i].code)) || '').toLowerCase();
      if (title === want) return true;
    }
    var items = cart.items || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var app = allocs[k] && allocs[k].discount_application;
        var name = String((app && (app.title || app.code)) || '').toLowerCase();
        if (name === want) return true;
      }
    }
    return false;
  }

  function cartHasAnyDiscount(cart) {
    if (!cart) return false;
    if (Number(cart.total_discount) > 0) return true;
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length > 0) return true;
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) {
      var allocs = items[i].line_level_discount_allocations || [];
      if (allocs.length > 0) return true;
    }
    return false;
  }

  function cartHasDiscountCodeApplied(cart) {
    if (!cart) return false;
    var apps = cart.cart_level_discount_applications || [];
    for (var i = 0; i < apps.length; i++) {
      if (apps[i] && apps[i].type === 'discount_code') return true;
    }
    var items = cart.items || [];
    for (var j = 0; j < items.length; j++) {
      var allocs = items[j].line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var app = allocs[k] && allocs[k].discount_application;
        if (app && app.type === 'discount_code') return true;
      }
    }
    return false;
  }

  function domShowsActiveDiscount() {
    return !!document.querySelector(
      '.axiom-minicart-breakdown__row--auto, .axiom-minicart-breakdown__row--code, .axiom-discount-pill, [data-axiom-discount-code]'
    );
  }

  function couponOverlapMessage(cart) {
    var hasDiscount = cartHasAnyDiscount(cart) || domShowsActiveDiscount();
    if (!hasDiscount) return '';
    if (cartHasDiscountCodeApplied(cart) || appliedDiscountCode()) {
      return 'A promo code is already applied. Only one code can be used per order.';
    }
    return 'A discount is already applied. Promo codes can\u2019t be combined with other offers.';
  }

  function resolveCouponErrorMessage(cart, fallback) {
    var overlap = couponOverlapMessage(cart);
    if (overlap) return overlap;
    return fallback || 'That code didn\u2019t apply. Check the code and try again.';
  }

  function fetchCartSnapshot() {
    return fetch(rootPath() + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .catch(function () {
        return null;
      });
  }

  function refreshMinicartInPlace(cart) {
    if (window.AxiomCart && typeof window.AxiomCart.refreshMinicart === 'function') {
      return window.AxiomCart.refreshMinicart(cart);
    }
    var formEl = document.getElementById('minicart-form');
    if (!formEl) return Promise.resolve();
    var root = rootPath();
    return fetch(root + '?sections=minicart-form')
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        var html = sections && sections['minicart-form'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('#minicart-form');
        if (next) formEl.innerHTML = next.innerHTML;
      });
  }

  function applyDiscountCode(code, opts) {
    var options = opts || {};
    var value = String(code || '').trim();
    if (!value) {
      if (!options.silent) showCouponError('Enter a code');
      return Promise.resolve(false);
    }
    if (!options.silent) showCouponError('');
    var root = rootPath();
    var applyBtn = document.querySelector('[data-axiom-discount-apply]');
    if (applyBtn) applyBtn.setAttribute('aria-busy', 'true');

    return fetch(root + 'discount/' + encodeURIComponent(value), {
      credentials: 'same-origin',
      redirect: 'follow',
    })
      .catch(function () {
        return null;
      })
      .then(function () {
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ discount: value }),
        });
      })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.errors || data.status) {
            var err = new Error(
              (data && (data.errors || data.description || data.message)) || 'Could not apply code'
            );
            err.payload = data;
            throw err;
          }
          return data;
        });
      })
      .then(function (cart) {
        if (window.AxiomCart && typeof window.AxiomCart.updateCartCounts === 'function') {
          window.AxiomCart.updateCartCounts(cart);
        }
        return refreshMinicartInPlace(cart).then(function () {
          return cart;
        });
      })
      .then(function (cart) {
        var pill = document.querySelector('[data-axiom-discount-code]');
        if (pill || codeAppliedInCart(cart, value)) {
          setPendingDiscount('');
          if (!options.silent) showCouponError('');
          return true;
        }
        if (!options.silent) {
          showCouponError(
            resolveCouponErrorMessage(cart, 'That code didn\u2019t apply. Check the code and try again.')
          );
        }
        return false;
      })
      .catch(function (err) {
        var fallback =
          (err && err.payload && (err.payload.description || err.payload.message || err.payload.errors)) ||
          (err && err.message) ||
          'That code didn\u2019t apply. Check the code and try again.';
        if (typeof fallback !== 'string') fallback = 'That code didn\u2019t apply. Check the code and try again.';
        if (options.silent) return false;
        return fetchCartSnapshot().then(function (cart) {
          showCouponError(resolveCouponErrorMessage(cart, fallback));
          return false;
        });
      })
      .finally(function () {
        if (applyBtn) applyBtn.removeAttribute('aria-busy');
      });
  }

  function ensureWelcomeDiscount() {
    if (appliedDiscountCode()) return Promise.resolve(false);
    var pending = getPendingDiscount();
    if (!pending) return Promise.resolve(false);
    return applyDiscountCode(pending, { silent: true });
  }

  window.AxiomCart = window.AxiomCart || {};
  window.AxiomCart.applyDiscountCode = applyDiscountCode;
  window.AxiomCart.setPendingDiscount = setPendingDiscount;
  window.AxiomCart.getPendingDiscount = getPendingDiscount;
  window.AxiomCart.ensureWelcomeDiscount = ensureWelcomeDiscount;

  document.addEventListener(
    'click',
    function (event) {
      var toggleBtn = event.target.closest('[data-axiom-coupon-toggle]');
      if (toggleBtn) {
        event.preventDefault();
        var root = toggleBtn.closest('[data-axiom-coupon]');
        var panel = root && root.querySelector('[data-axiom-coupon-panel]');
        if (!panel) return;
        var open = panel.hasAttribute('hidden');
        if (open) {
          panel.removeAttribute('hidden');
          toggleBtn.setAttribute('aria-expanded', 'true');
        } else {
          panel.setAttribute('hidden', '');
          toggleBtn.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      var ladderBtn = event.target.closest('[data-axiom-ladder-add]');
      if (ladderBtn) {
        event.preventDefault();
        event.stopPropagation();
        var ladder = ladderBtn.closest('[data-axiom-cart-ladder]');
        var variantId = ladder && ladder.getAttribute('data-variant-id');
        var addQty = Number(ladderBtn.getAttribute('data-qty') || 1);
        if (!variantId || !addQty) return;
        ladderBtn.setAttribute('aria-busy', 'true');
        var addUrl = rootPath() + 'cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: addQty }],
          }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || data.errors || data.status) {
                throw new Error((data && (data.description || data.message)) || 'Add failed');
              }
              return data;
            });
          })
          .then(function () {
            return fetch(rootPath() + 'cart.js').then(function (r) {
              return r.json();
            });
          })
          .then(function (cart) {
            if (window.AxiomCart && typeof window.AxiomCart.updateCartCounts === 'function') {
              window.AxiomCart.updateCartCounts(cart);
            }
            if (window.AxiomCart && typeof window.AxiomCart.refreshMinicart === 'function') {
              return window.AxiomCart.refreshMinicart(cart);
            }
            location.reload();
          })
          .catch(function () {
            location.reload();
          })
          .finally(function () {
            ladderBtn.removeAttribute('aria-busy');
          });
        return;
      }

      var clearBtn = event.target.closest('[data-axiom-discount-clear]');
      if (clearBtn) {
        removeDiscountCode(event);
        return;
      }

      var applyBtn = event.target.closest('[data-axiom-discount-apply]');
      if (applyBtn) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        var wrap = applyBtn.closest('.axiom-minicart-coupon, .cart-discount-code') || document;
        var input =
          wrap.querySelector('[data-axiom-discount-input], .discount_code, input[name="discount"]') ||
          document.getElementById('MinicartDiscountCode');
        applyDiscountCode(input && input.value);
        return;
      }

      var welcomeBtn = event.target.closest('[data-axiom-discount-welcome]');
      if (welcomeBtn) {
        event.preventDefault();
        event.stopPropagation();
        setPendingDiscount(WELCOME_CODE);
        var input = document.querySelector('[data-axiom-discount-input], #MinicartDiscountCode');
        if (input) input.value = WELCOME_CODE;
        applyDiscountCode(WELCOME_CODE);
        return;
      }

      var checkoutBtn = event.target.closest('[name="checkout"], .btn-checkout, .cart__checkout-button');
      if (!checkoutBtn) return;
      var code = appliedDiscountCode() || getPendingDiscount();
      if (!code) return;
      event.preventDefault();
      if (!appliedDiscountCode() && getPendingDiscount()) {
        applyDiscountCode(code, { silent: true }).finally(function () {
          window.location.href = checkoutUrl(code);
        });
        return;
      }
      window.location.href = checkoutUrl(code);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target;
      if (!input || !input.matches('[data-axiom-discount-input], #MinicartDiscountCode')) return;
      event.preventDefault();
      applyDiscountCode(input.value);
    },
    true
  );

  // If shopper claimed Welcome10 earlier, attach it when the cart drawer opens.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.minicart__action, #cart-icon-bubble')) return;
    setTimeout(function () {
      ensureWelcomeDiscount();
    }, 250);
  });
})();
